module.exports = __webpack_public_path__ + "326a144c0e6406d29eacccb0113593f2.png";